import { render, staticRenderFns } from "./TractionSupportForm.vue?vue&type=template&id=4526bdbc&scoped=true&"
import script from "./TractionSupportForm.vue?vue&type=script&lang=js&"
export * from "./TractionSupportForm.vue?vue&type=script&lang=js&"
import style0 from "./TractionSupportForm.vue?vue&type=style&index=0&id=4526bdbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4526bdbc",
  null
  
)

export default component.exports